<template>
  <div class='s-footer'>
      <slot></slot>
  </div>
</template>

<script>
export default {
    name: 's-footer'
}
</script>

<style>
.s-footer {
  height: 60px;
}
</style>